import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#02501A" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            {/* <CFLink href="https://www.facebook.com/vancitymasa/">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Yume Dining Facebook"
              />
            </CFLink> */}
            <CFLink href="https://www.instagram.com/yume.dining">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Yume Dining Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#02501A" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            {/* <CFLink href="https://www.facebook.com/vancitymasa/">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Yume Dining Facebook"
                hover
              />
            </CFLink> */}
            <CFLink href="https://www.instagram.com/yume.dining">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Yume Dining Instagram"
                hover
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
